<template>
  <my-giving-layout>
    <div class="bg-paper w-full min-h-full px-[24px] flex flex-col items-center text-center">
      <!-- Content container - vertically centered -->
      <div class="flex-1 flex flex-col items-center justify-center pb-[32px]">
        <img src="/assets/images/my-giving/rcsuccess.png" alt="Top Image" class="w-32 h-32 mb-4" />

        <div
          class="text-[2.25rem] leading-[2.0625rem] font-black text-[#2B2926] tracking-[-0.03em]"
        >
          Request is being processed
        </div>
        <p class="mt-[16px]">
          Recurring giving will be removed from <b>Manage My Giving</b>. We'll notify you after 1
          working day when it's completed.

          <br /><br />

          For any queries, you may reach out to
          <a href="mailto:accounts@heartofgodchurch.org" class="underline text-[#454BEF]">
            accounts@heartofgodchurch.org
          </a>
        </p>
      </div>

      <!-- At the bottom of this full-height column, below the content if it grows. -->
      <div
        class="mt-auto w-full max-w-[600px] flex flex-col gap-[16px] pb-[max(32px,calc(env(safe-area-inset-bottom)+16px))]"
      >
        <div
          @click="goToManageRecurring"
          class="border-[2px] border-[#42362B] w-full bg-[#F6F4F0] text-[#21201E] text-[1rem] md:text-[1.375rem] lg:text-[1.5rem] font-semibold rounded-[100px] py-[14px] md:py-[18px] lg:py-[20px] text-center"
        >
          See Status
        </div>

        <BottomButton
          id="generate-qr-code"
          text="Back to MyGiving"
          :disabled="isButtonDisabled"
          :fontSize="16"
          @click="goToManageGiving"
          class="w-full mb-[0px]"
        />
      </div>
    </div>
  </my-giving-layout>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
import MyGivingLayout from '@/components/MyGivingLayout.vue';
export default {
  name: 'RemoveRecurring',
  components: {
    BottomButton,
    MyGivingLayout,
  },
  data() {
    return {
      isButtonDisabled: false,
    };
  },
  methods: {
    goToManageRecurring() {
      this.$router.replace('/my-giving/manage#recurring');
    },
    goToManageGiving() {
      this.$router.replace('/my-giving');
    },
  },
};
</script>
